import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Hero from "../components/Hero";
import destImg from "../assests/images/hotel-bg.jpg"; // you can change image

export default function DestinationsList({
    showBanner = true,
    showHeading = true
}) {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    // Fetch destinations
    const fetchDestinations = async () => {
        setLoading(true);
        try {
            const res = await axios.get("https://jumeiradiscounthotels.com/api/destinations");
            setDestinations(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDestinations();
    }, []);

    return (
        <div className="w-full">
            {/* Banner */}
            {showBanner && (
                <Hero
                    variant="inner"
                    title="All Destinations"
                    subtitle="Explore amazing places around the world"
                    backgroundImage={destImg}
                />
            )}

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">

                {/* Heading */}
                {showHeading && (
                    <div className="mb-8">
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A]">
                            All Destinations
                        </h2>
                        <p className="text-orange-500 mt-2">
                            Discover the best destinations for your next trip
                        </p>
                    </div>
                )}

                {/* Loading */}
                {loading ? (
                    <div className="flex justify-center py-20">
                        <div className="animate-spin h-12 w-12 border-4 border-[#0F172A] border-t-transparent rounded-full"></div>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {destinations.map((dest) => (
                            <div
                                key={dest.id}
                                onClick={() => navigate(`/destinations/${dest.slug}`)}
                                className="relative h-60 rounded-2xl overflow-hidden cursor-pointer group shadow-md hover:shadow-xl hover:ring-2 hover:ring-[#0F172A] transition"
                            >
                                {/* Image */}
                                <img
                                    src={`https://uaediscountedhotels.com/uploads/destinations/${dest.image}`}
                                    alt={dest.name}
                                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                                />

                                {/* Overlay */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

                                {/* Content */}
                                <div className="absolute bottom-4 left-4 right-4 text-white">
                                    <h3 className="text-lg font-bold text-orange-100">
                                        {dest.name}
                                    </h3>
                                    <p className="text-sm text-orange-200">
                                        {dest.hotels_count} Hotels
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}